module.exports = {"service":{"adFeed":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/creatives/{locale}{origin}.json","newsfeed":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/news/{locale}.json","motd":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/motd/{locale}.json"},"ads":{"fallback":{"click_url":"https://secure.eveonline.com/AddGametime/?utm_source=launcher&utm_campaign=Omega&utm_medium=banner&utm_term=Omega&utm_content=Omega&origin={origin}","image_url":"/content/images/creatives/omega-{locale}.png"}}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/attributes.dev.json
// module id = 509
// module chunks = 0